export function downloadBlob(data: Blob, selectedType: string, nameExport?:string) {
    const blob = new Blob(
        [data],
        selectedType === 'csv' ? { type: 'application/csv' } : { type: 'application/vnd.ms-excel' }
    );

    const objectUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = nameExport ? `${nameExport}.${selectedType}` : `export.${selectedType}`;
    link.click();

    URL.revokeObjectURL(objectUrl);
}
